import { call, put, takeEvery } from "redux-saga/effects";
import {
  DELETE_REPORT,
  APPROVE_REPORT,
  GENERATE_REPORT,
  GET_REFIENED_PROGRESS_NOTES_LIST,
  GET_REPORT_LOGS,
  OPEN_AI_REFINE_TEXT,
  STORE_REFINED_TEXT,
  UPDATE_REPORT,
  REPORT_ATTACHMENT_LIST,
  SAVE_REPORT_ATTACHMENT,
  DELETE_REPORT_ATTACHMENT,
  GET_TASK_REPORT_DETAIL,
} from "./actionTypes";
import {
  generateReportSuccess,
  generateReportFail,
  refineTextSuccess,
  refineTextFail,
  storeRefinedTextSuccess,
  storeRefinedTextFail,
  getNotesListSuccess,
  getNotesListFail,
  updateReportSuccess,
  updateReportFail,
  deleteReportSuccess,
  deleteReportFail,
  getReportLogsSuccess,
  getReportLogsFail,
  approveReportSuccess,
  approveReportFail,
  reportAttachmentListSuccess,
  reportAttachmentListFail,
  saveReportAttachmentsSuccess,
  saveReportAttachmentsFail,
  deleteReportAttachmentsSuccess,
  deleteReportAttachmentsFail,
  participantTaskReportSuccess,
  participantTaskReportFail,
} from "./actions";
import {
  onGeneratingReport,
  onApprovingReport,
  onRefiningText,
  onGettingRefinedTest,
  onStoringRefinedText,
  onUpdatingOpenAiReport,
  onDeletingOpenAiReport,
  onGettingReportLogs,
  onGettingReportAttchList,
  onSavingReportAttachList,
  onDeletingReportAttach,
  onGettingReportDetail,
} from "helpers/fakebackend_helper";
import showToast from "common/Notification";
import { responseHandler } from "common/CommanFunction";

const toastTitle = "Report";

function* onApproveReport({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onApprovingReport, data);
    yield call(responseHandler, toastTitle, response, approveReportSuccess, approveReportFail, onSuccess, onError, false);
  } catch (error) {
    onError();
    yield put(approveReportFail(error));
    showToast(error, toastTitle, error);
    console.log(error);
  }
}

function* onGenerateReport({ payload: { data, onSuccess, onError, dispatch } }) {
  try {
    const response = yield call(onGeneratingReport, data);
    yield call(responseHandler, toastTitle, response, generateReportSuccess, generateReportFail, onSuccess, onError, false);
  } catch (error) {
    onError();
    yield put(generateReportFail(error));
    showToast(error, toastTitle, error);
    console.log(error);
  }
}

function* onRefineText({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onRefiningText, data);
    yield call(responseHandler, toastTitle, response, refineTextSuccess, refineTextFail, onSuccess, onError, false);
  } catch (error) {
    onError();
    yield put(refineTextFail(error));
    showToast(error, toastTitle, error);
    console.log(error);
  }
}

function* onStoreRefinedText({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onStoringRefinedText, data);
    yield call(responseHandler, toastTitle, response, storeRefinedTextSuccess, storeRefinedTextFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(storeRefinedTextFail(error));
    showToast(error, toastTitle, error);
    console.log(error);
  }
}

function* onGetRefinedTest({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onGettingRefinedTest, data);
    yield call(responseHandler, toastTitle, response, getNotesListSuccess, getNotesListFail, onSuccess, onError, false);
  } catch (error) {
    onError();
    yield put(getNotesListFail(error));
    showToast(error, toastTitle, error);
    console.log(error);
  }
}

function* onUpdate({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onUpdatingOpenAiReport, data);
    yield call(responseHandler, toastTitle, response, updateReportSuccess, updateReportFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(updateReportFail(error));
    showToast(error, toastTitle, error);
    console.log(error);
  }
}

function* onDelete({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onDeletingOpenAiReport, data);
    yield call(responseHandler, toastTitle, response, deleteReportSuccess, deleteReportFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(deleteReportFail(error));
    showToast(error, toastTitle, error);
    console.log(error);
  }
}

function* onGetLogs({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onGettingReportLogs, data);
    yield call(responseHandler, toastTitle, response, getReportLogsSuccess, getReportLogsFail, onSuccess, onError, false);
  } catch (error) {
    onError();
    yield put(getReportLogsFail(error));
    showToast(error, toastTitle, error);
    console.log(error);
  }
}

function* onGetReportAttachmentList({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onGettingReportAttchList, data);
    yield call(responseHandler, toastTitle, response, reportAttachmentListSuccess, reportAttachmentListFail, onSuccess, onError, false);
  } catch (error) {
    onError();
    yield put(getReportLogsFail(error));
    showToast(error, toastTitle, error);
    console.log(error);
  }
}

function* onSaveAttachmentList({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onSavingReportAttachList, data);
    yield call(responseHandler, toastTitle, response, saveReportAttachmentsSuccess, saveReportAttachmentsFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(getReportLogsFail(error));
    showToast(error, toastTitle, error);
    console.log(error);
  }
}

function* onDeleteAttachment({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onDeletingReportAttach, data);
    yield call(responseHandler, toastTitle, response, deleteReportAttachmentsSuccess, deleteReportAttachmentsFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(getReportLogsFail(error));
    showToast(error, toastTitle, error);
    console.log(error);
  }
}

function* onGetReportDetail({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onGettingReportDetail, data);
    yield call(responseHandler, toastTitle, response, participantTaskReportSuccess, participantTaskReportFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(participantTaskReportFail(error));
    showToast(error, toastTitle, error);
  }
}

export function* ChatGPTSaga() {
  yield takeEvery(DELETE_REPORT, onDelete);
  yield takeEvery(UPDATE_REPORT, onUpdate);
  yield takeEvery(GET_REPORT_LOGS, onGetLogs);
  yield takeEvery(APPROVE_REPORT, onApproveReport);
  yield takeEvery(GENERATE_REPORT, onGenerateReport);
  yield takeEvery(OPEN_AI_REFINE_TEXT, onRefineText);
  yield takeEvery(STORE_REFINED_TEXT, onStoreRefinedText);
  yield takeEvery(GET_TASK_REPORT_DETAIL, onGetReportDetail);
  yield takeEvery(SAVE_REPORT_ATTACHMENT, onSaveAttachmentList);
  yield takeEvery(DELETE_REPORT_ATTACHMENT, onDeleteAttachment);
  yield takeEvery(REPORT_ATTACHMENT_LIST, onGetReportAttachmentList);
  yield takeEvery(GET_REFIENED_PROGRESS_NOTES_LIST, onGetRefinedTest);
}

export default ChatGPTSaga;
